import script from "./musicalIntroduction.vue?vue&type=script&setup=true&lang=js"
export * from "./musicalIntroduction.vue?vue&type=script&setup=true&lang=js"

import "./musicalIntroduction.vue?vue&type=style&index=0&id=c2adee18&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2adee18"]])

export default __exports__